const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;
const clearAllBodyScrollLocks = bodyScrollLock.clearAllBodyScrollLocks;

export default function modalInit() {

    let modal = this,
        $html = $('html'),
        $wrapper = $('.wrapper'),
        $window = $(window),
        $wrap = $('.modal-wrap'),
        tm_modal = [null, 300],
        scrollTop = 0;

    modal.scrollAPI = new function () {
        let scrollAPI = this;
        scrollAPI.fix = function () {
            disableBodyScroll($html, {
                reserveScrollBarGap: true,
                allowTouchMove: el => {
                    while (el && el !== document.body) {
                        if (el.getAttribute('data-enable-scroll') !== null) {
                            return true;
                        }
                        el = el.parentNode;
                    }
                },
            });
            // scrollTop = $window.scrollTop();
            // $html.toggleClass('_overflow-hidden', true);
            // $window.scrollTop(0);
            // $wrapper.scrollTop(scrollTop);
        };
        scrollAPI.loose = function () {
            enableBodyScroll($html, {reserveScrollBarGap: true});
            clearAllBodyScrollLocks();
            // $html.toggleClass('_overflow-hidden', false);
            // $window.scrollTop(scrollTop);
        };
    };

    /*let scrollTop=$window.scrollTop();
     $('html').addClass('_overflow-hidden');
     $('.wrapper').scrollTop(scrollTop);*/

    modal.modalOpen = function (selector, source) {
        let $this = $('[data-modal=' + selector + ']'),
            $wrap = $this.parents('.modal-wrap');

        if (source) {
            $('[data-modal-content-target]', $this).html(source);
        }

        $this.addClass('_active');
        $wrap.addClass('_active');

        modal.scrollAPI.fix();
        $this.trigger('modal:opened');

        clearTimeout(tm_modal[0]);
        tm_modal[0] = setTimeout(function () {
            $this.removeClass('_fade');
            $wrap.removeClass('_fade');
        }, 20);
        // modal.resizeContent();
        if (selector === 'modal-agreement' && $('[data-modal="modal-quick-purchase"]').hasClass('_active')) {
            $('[data-modal="modal-quick-purchase"]').removeClass('_active').addClass('_dependModal');
        }
        
        if (selector === 'modal-search') {
            $this.find('.search-input').click();
            setTimeout(() => $this.find('.search-input').focus(), 500);
        }
    };

    modal.modalClose = function (selector, event) {
        if ($('[data-modal="modal-agreement"]').hasClass('_active') && $('[data-modal="modal-quick-purchase"]').hasClass('_dependModal')) {
            $('[data-modal="modal-quick-purchase"]').removeClass('_dependModal').addClass('_active');
            $('[data-modal="modal-agreement"]').removeClass('_active');
            event.preventDefault();
        }
        if (selector) {
            let $this = $('[data-modal=' + selector + ']');
            $this.trigger('modal:closed');

            $this.addClass('_fade');
            $wrap.addClass('_fade');

            clearTimeout(tm_modal[0]);
            tm_modal[0] = setTimeout(function () {
                $this.trigger('modal:closed-full');

                $this.removeClass('_active');
                $wrap.removeClass('_active');

                modal.scrollAPI.loose();
            }, tm_modal[1]);
        }
        else {
            $('.modal._active').trigger('modal:closed');

            $('.modal').addClass('_fade');
            $wrap.addClass('_fade');

            clearTimeout(tm_modal);
            setTimeout(function () {

                $('.modal._active').trigger('modal:closed-full');

                $('.modal').removeClass('_active');
                $wrap.removeClass('_active');

                modal.scrollAPI.loose();
            }, 300);

        }
    };

    $('body').on('click', '[data-modal-open]', handlerModalOpen);

    $('body').on('click', '[data-modal-close]', function () {
        modal.modalClose();
    });

    $('body').on('click', '[data-modal-toggle]', function (event) {
        let $this = $(this);
        if($this.data('modal-toggle')===true) {
            $this.data('modal-toggle', false);
            $this.toggleClass('_modal-active', false);
            modal.modalClose();
        }
        else {
            $this.data('modal-toggle', true);
            $this.toggleClass('_modal-active', true);
            handlerModalOpen(event, $this.data('modal-target'));
        }
    });

    $('[data-modal=nav]').on('modal:opened', handlerNavOpened);
    $('[data-modal=nav]').on('modal:closed', handlerNavClosed);

    $(document).on('keydown', function (event) {
        if (event.keyCode == 27) {
            if ($('.modal-wrap').hasClass('_active')) {
                modal.modalClose();
            }
        }
    });

    /*modal.resizeContent=function () {
     $('.modal iframe').each(function () {
     $(this).get(0).height=app.windowSize.height[0]-app.windowSize.height[0]*0.3;
     });
     };*/

    // handlers
    function handlerModalOpen(e, selector) {
        e.preventDefault();
        let $this = $(this);
        if ($this.data('modal-source')) {
            let dataSource = $this.data('modal-source');
            if (dataSource == "parent") {
                let $parent = $this.parents('[data-modal-content-parent]');
                modal.modalOpen($this.data('modal-open'), $('[data-modal-content-source]', $parent).html());
            }
            else {
                modal.modalOpen($this.data('modal-open'), $('[data-modal-content-source=' + dataSource + ']').html());
            }
        }
        else {
            if(selector!=undefined) {
                modal.modalOpen(selector);
            }
            else {
                modal.modalOpen($this.data('modal-open'));
            }
        }
    }

    function handlerNavOpened(event) {
        $('html').toggleClass('_nav-opened', true);
        // $('[data-modal-open=nav]').toggleClass('_active', true);
    }

    function handlerNavClosed(event) {
        $('html').toggleClass('_nav-opened', false);
        // $('[data-modal-open=nav]').toggleClass('_active', false);
    }

}